<ng-container *ngFor="let planStepAction of planStepActions; let i = index">
    <mat-icon *ngIf="i > 0">arrow_right_alt</mat-icon>
    <span>{{planStepActionHelper.getActionName(planStepAction, 'uppercase')}}</span>
</ng-container>